module.exports = __webpack_public_path__ + "img/Bahamas.4637a5d0.svg";